/* Get Joy nav (Oct 2026): sheet, desktop panels, visitor-state pill, cart count, analytics. */
(function () {
  var root = document.getElementById('gjzNav');
  if (!root) return;
  /* the mobile sheet is moved to <body> below (portal), so lookups search the nav and the portal */
  var portal = null;
  var $ = function (s, c) { return c ? c.querySelector(s) : (root.querySelector(s) || (portal && portal.querySelector(s))); };
  var $$ = function (s, c) { var a = Array.prototype.slice.call((c || root).querySelectorAll(s)); if (!c && portal) a = a.concat(Array.prototype.slice.call(portal.querySelectorAll(s))); return a; };
  var html = document.documentElement;
  var desk = window.matchMedia('(min-width:1024px)');
  function track(ev, data) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev, nav_device: desk.matches ? 'desktop' : 'mobile' }, data || {})); } catch (e) {} }

  /* ---------- mobile sheet ---------- */
  var btn = $('#gjznMenuBtn'), sheet = $('#gjznSheet'), ml = $('#gjznMl'), bar = $('#gjznBar');
  var lastFocus = null;
  /* Fixed elements inside the sticky header are hit-tested unreliably on mobile Chrome (taps and swipes
     fall through to the page). Living directly under <body> avoids that whole class of bug. */
  if (sheet) { portal = document.createElement('div'); portal.className = 'gjzn gjzn-portal'; document.body.appendChild(portal); portal.appendChild(sheet); }
  function setTop() { var r = bar.getBoundingClientRect(); sheet.style.setProperty('--gjzn-top', Math.max(0, Math.round(r.bottom)) + 'px'); }
  function openSheet() {
    lastFocus = document.activeElement; setTop();
    sheet.hidden = false; btn.setAttribute('aria-expanded', 'true'); ml.textContent = 'Close';
    window.scrollTo(window.scrollX, window.scrollY); /* stop any coasting flick before locking */
    html.classList.add('gjzn-lock'); sheet.scrollTop = 0;
    var tablet = window.matchMedia('(min-width:768px)').matches; $('#gjznScrim').hidden = !tablet;
    track('nav_open', {});
  }
  function closeSheet(restore) {
    if (sheet.hidden) return;
    sheet.hidden = true; btn.setAttribute('aria-expanded', 'false'); ml.textContent = 'Menu';
    html.classList.remove('gjzn-lock'); $('#gjznScrim').hidden = true;
    if (restore !== false && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  btn.addEventListener('click', function () { sheet.hidden ? openSheet() : closeSheet(); });
  window.addEventListener('resize', function () { if (!sheet.hidden) setTop(); if (desk.matches) closeSheet(false); });
  sheet.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href],button,input', sheet).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); btn.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); btn.focus(); }
  });

  /* ---------- desktop panels (click, or hover with a 350 ms delay) ---------- */
  var openers = $$('[data-panel]'), current = null, hoverT = 0, hoverAt = 0;
  function panelEl(n) { return $('#gjzn' + n.charAt(0).toUpperCase() + n.slice(1)); }
  function setPanel(name, how) {
    if (name === current) return;
    openers.forEach(function (o) { var on = o.getAttribute('data-panel') === name; o.setAttribute('aria-expanded', on ? 'true' : 'false'); var p = panelEl(o.getAttribute('data-panel')); if (p) p.hidden = !on; });
    $('#gjznScrim').hidden = !name; current = name;
    if (name && how === 'hover') hoverAt = Date.now();
    if (name) track('nav_panel_open', { panel: name, trigger: how || 'click' });
  }
  openers.forEach(function (o) {
    var n = o.getAttribute('data-panel');
    o.addEventListener('click', function () { clearTimeout(hoverT); if (current === n && Date.now() - hoverAt < 700) return; /* hover just opened it: a click right after should not close it */ setPanel(current === n ? null : n, 'click'); });
    o.addEventListener('mouseenter', function () { clearTimeout(hoverT); hoverT = setTimeout(function () { setPanel(n, 'hover'); }, current ? 0 : 350); });
    o.addEventListener('mouseleave', function () { clearTimeout(hoverT); });
  });
  $('#gjznScrim').addEventListener('click', function () { setPanel(null); closeSheet(); });
  /* desktop: a panel closes on its own shortly after the pointer leaves the bar + panel (onto the page or the scrim) */
  var leaveT = 0, scrim = $('#gjznScrim');
  function leaveSoon() { if (!current || !desk.matches) return; clearTimeout(leaveT); leaveT = setTimeout(function () { setPanel(null); }, 350); }
  root.addEventListener('mouseleave', leaveSoon);
  scrim.addEventListener('mouseenter', leaveSoon);
  root.addEventListener('mouseover', function (e) { if (e.target !== scrim) clearTimeout(leaveT); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (current) { var o = $('[data-panel="' + current + '"]'); setPanel(null); if (o) o.focus(); }
    if (!sheet.hidden) closeSheet();
  });
  document.addEventListener('click', function (e) { if (current && !root.contains(e.target) && !(portal && portal.contains(e.target))) setPanel(null); });

  /* ---------- visitor state: quiz resume (client) ---------- */
  var state = root.getAttribute('data-state');
  var pill = $('#gjznPill'), pillT = $('#gjznPillT'), dot = $('#gjznDot'), annT = $('#gjznAnnT'), ann = $('#gjznAnn');
  if (state === 'new') {
    try {
      var raw = localStorage.getItem('gj_quiz_state_v1');
      var st = raw ? JSON.parse(raw) : null;
      var a = st && st.a;
      if (a && a.name && st.screen && st.screen !== 'invite') {
        var name = String(a.name).replace(/[<>&"']/g, '').trim();
        var label = name && name.length <= 10 ? name + '’s plan' : 'Your plan';
        pillT.textContent = label; dot.hidden = false; root.setAttribute('data-state', 'resume');
        if (st.screen === 'plan' || st.screen === 'build') {
          var pdp = a.format === 'fresh' ? '/products/joy-meal' : '/products/freeze-dried-raw';
          var q = '?dog=' + encodeURIComponent(name) + (a.weight ? '&w=' + encodeURIComponent(a.weight) : '') + (a.protein ? '&protein=' + encodeURIComponent(a.protein) : '') + (a.mode ? '&mode=' + encodeURIComponent(a.mode) : '') + '&src=nav_resume';
          pill.href = pdp + q;
        } else {
          pill.href = '/pages/quiz?src=nav_resume';
        }
        if (annT && name.length <= 14) { annT.textContent = name + '’s 50% off is waiting'; if (ann) ann.href = '/pages/quiz?src=announce_resume'; }
      }
    } catch (e) {}
  }

  /* ---------- meal PDP: "Size their plan" opens the page's own sizing ---------- */
  if (state === 'pdp') {
    pill.addEventListener('click', function (e) {
      e.preventDefault(); track('nav_quiz_click', { surface: 'pill', state: 'pdp' });
      var help = document.querySelector('[data-gjx=helper-open],[data-gjf=sheet-open]');
      var box = document.querySelector('[data-gjx=steps],[data-gjf=weight],[data-gjx-root],[data-gjf-root]');
      if (help && help.offsetParent !== null) { help.click(); return; }
      if (box) { var y = box.getBoundingClientRect().top + window.scrollY - 80; window.scrollTo({ top: y, behavior: 'smooth' }); }
      else window.location.href = '/pages/quiz?src=nav_pill_pdp';
    });
  }

  /* ---------- analytics on every nav link ---------- */
  function navClick(e) {
    var a = e.target.closest('a[data-nav]'); if (!a) return;
    var d = a.getAttribute('data-nav');
    if (d === 'pill' || d === 'plan-card' || d === 'announce') { if (state !== 'pdp' || d !== 'pill') track('nav_quiz_click', { surface: d, state: root.getAttribute('data-state') }); }
    else if (d === 'need') track('nav_need_chip', { need: a.getAttribute('data-need') });
    else if (d === 'account' || d === 'tracking' || d === 'contact') track('nav_account_click', { dest: d });
    else track('nav_click', { dest: d, href: a.getAttribute('href') });
  }
  root.addEventListener('click', navClick); if (portal) portal.addEventListener('click', navClick);

  /* ---------- cart count (line items, like the old header) ---------- */
  function updCount() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var n = (c.items || []).length;
      $$('[data-gjzn-count]').forEach(function (b) { b.textContent = n > 9 ? '9+' : String(n); b.hidden = n === 0; });
    }).catch(function () {});
  }
  ['ajaxProduct:added', 'rebuy:cart.change', 'rebuy:cart.ready', 'cart:refresh', 'petSelection:add'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(updCount, 250); }); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) updCount(); });

  /* ---------- cart icon: open the Rebuy drawer when it is ready, else go to /cart ---------- */
  $$('.gjzn-cart').forEach(function (c) {
    c.addEventListener('click', function (e) {
      var sc = window.Rebuy && window.Rebuy.SmartCart;
      if (sc && typeof sc.show === 'function') { e.preventDefault(); sc.show(); }
    });
  });

  /* ---------- carried over from the old header: reopen the cart after a redirect ---------- */
  try {
    if (sessionStorage.getItem('openCartOnLoad') === 'true') {
      sessionStorage.removeItem('openCartOnLoad');
      /* Open the drawer through Rebuy once it is ready. Never click the /cart link here:
         before Rebuy loads that link navigates to /cart, which redirects back and loops. */
      var tries = 0;
      (function openWhenReady() {
        var sc = window.Rebuy && window.Rebuy.SmartCart;
        if (sc && typeof sc.show === 'function') { sc.show(); return; }
        if (++tries < 40) setTimeout(openWhenReady, 250);
      })();
    }
  } catch (e) {}
})();
